import { httpService } from '../utils/http';
import {
  ApiResponse,
  Page,
  WxAppVO,
  WxAppQueryRequest,
  WxAppSaveRequest,
  MerchantOption,
} from '../types';

class WxAppService {
  private readonly baseUrl = '/wxApp';

  getList(params: WxAppQueryRequest): Promise<ApiResponse<Page<WxAppVO>>> {
    return httpService.post(`${this.baseUrl}/list`, params);
  }

  save(params: WxAppSaveRequest): Promise<ApiResponse<WxAppVO>> {
    return httpService.post(`${this.baseUrl}/save`, params);
  }

  update(params: WxAppSaveRequest): Promise<ApiResponse<WxAppVO>> {
    return httpService.post(`${this.baseUrl}/update`, params);
  }

  delete(id: number): Promise<ApiResponse<null>> {
    return httpService.post(`${this.baseUrl}/delete`, { id });
  }

  bindMerchant(appId: number, merchantId: number): Promise<ApiResponse<null>> {
    return httpService.post(`${this.baseUrl}/bindMerchant`, { appId, merchantId });
  }

  unbindMerchant(appId: number): Promise<ApiResponse<null>> {
    return httpService.post(`${this.baseUrl}/unbindMerchant`, { appId });
  }

  getMerchantOptions(): Promise<ApiResponse<MerchantOption[]>> {
    return httpService.post(`${this.baseUrl}/merchantOptions`);
  }
}

export const wxAppService = new WxAppService();
